<script>
import Vue from 'vue';
import { Checkbox } from 'element-ui';
import OauthConnectLink from '~/components/oauth/components/oauth_connect_link';

Vue.use(Checkbox);

export default {

    components: {
        OauthConnectLink,
    },

    props: {
        systemName: {
            type: String,
            default: null,
        },

        name: {
            type: String,
            default: null,
        },

        profileImg: {
            type: String,
            default: null,
        },

        username: {
            type: String,
            default: null,
        },

        accountType: {
            type: String,
            default: null,
        },

        networkId: {
            type: [Number, String],
            default: null,
        },

        accountId: {
            type: [Number, String],
            default: null,
        },

        pageId: {
            type: [Number, String],
            default: null,
        },

        gatewayId: {
            type: [Number, String],
            default: null,
        },

        selected: {
            type: Array,
            default: () => [],
        },

        isConnected: {
            type: [Boolean, String],
            default: false,
        },

        isPermitted: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            icon: null,
            color: null,
        };
    },

    computed: {
        isChecked: {
            get() {
                const socialTypeMatch = this.selected.filter(item => item.account_type === this.accountType);
                return socialTypeMatch.some(item => item.account_type === 'page_id' ? item.page_id === this.pageId : item.account_id === this.accountId);
            },
            set(value) {
                this.value = value;
            },
        },
        getNetworkName: {
            get() {
              /*
              because instagram is dependent on the facebook integration it needs to
              go through the facebook connect process instead of a dedicated instagram connect
              */
                if (this.systemName === 'instagram') {
                    return 'facebook';
                }
                return this.systemName;
            },

            set(value) {
                this.value = value;
            },
        }
    },

    watch: {
        systemName(value) {
            this.setNetworkStyles();
        },
    },

    mounted() {
        this.setNetworkStyles();
    },

    methods: {
        change(event) {
            this.$emit('change', event.target.checked, {
                network_id: this.networkId,
                system_name: this.systemName,
                account_id: this.accountId,
                page_id: this.pageId,
                account_type: this.accountType,
            });
        },

        connect(name, payload) {
            this.$emit('connect', name, payload);
        },

        setNetworkStyles() {
            switch (this.systemName) {
                case 'facebook':
                    this.icon = 'fa fa-facebook';
                    this.color = '#3B5998';
                    break;
                case 'instagram':
                    this.icon = 'fa fa-instagram';
                    this.color = '#3B5998';
                    break;
                case 'twitter':
                    this.icon = 'fa fa-twitter';
                    this.color = '#00aced';
                    break;
                case 'linkedin':
                    this.icon = 'fa fa-linkedin-square';
                    this.color = '#0e76a8';
                    break;
            }
        },
    },
};
</script>

<template>
    <div v-if="isPermitted">
        <template v-if="isConnected">
            <el-checkbox
                :value="isChecked"
                class="m-0 btn btn-white"
                :style="{height: '36px'}"
                @change="change"
            >
                <span class="p-l-5">
                    <template v-if="profileImg && username">
                        <img :src="profileImg" class="btn__avatar">

                        <span class="fa-stack fa-lg btn__social-avatar-icon">
                            <i :class="['fa fa-circle fa-stack-2x']" :style="{color:color}" />
                            <i :class="[icon, 'fa-inverse', 'fa-stack-1x']" />
                        </span>

                        {{ username }}
                    </template>

                    <template v-else-if="username">
                        <i :class="[icon]" :style="{color:color}" /> {{ username }}
                    </template>

                    <template v-else>
                        <i :class="[icon]" :style="{color:color}" /> {{ name }}
                    </template>
                </span>
            </el-checkbox>
        </template>

        <template v-else>
            <oauth-connect-link
                type="white"
                :integration-name="getNetworkName"
                @connect="connect"
            >
                <i :class="[icon, 'p-r-5']" :style="{color:color, padding: '4px 0'}" /> Connect {{ name }}
            </oauth-connect-link>
        </template>
    </div>
</template>
